// Simplified Amplify config adapted from webapp/src/aws-exports.js

const REGION = (import.meta.env.VITE_REGION as string | undefined) ?? 'us-west-2';
const USER_POOL_REGION =
  (import.meta.env.VITE_USER_POOL_REGION as string | undefined) ?? 'us-west-2';
const USER_POOL_ID = (import.meta.env.VITE_USER_POOL_ID as string | undefined) ?? 'IPrFnT79V';
const USER_POOL_CLIENT_ID =
  (import.meta.env.VITE_USER_POOL_CLIENT_ID as string | undefined) ?? '6k2dift2qvf1nsqno31vpvn21e';
const REDIRECT_URL =
  (import.meta.env.VITE_REDIRECT_URL as string | undefined) ?? 'http://localhost:5173';
const AUTH_DOMAIN =
  (import.meta.env.VITE_AUTH_DOMAIN as string | undefined) ??
  'example.auth.us-west-2.amazoncognito.com';

export const awsmobile = {
  aws_project_region: REGION,
  aws_cognito_region: USER_POOL_REGION,
  aws_user_pools_id: `${USER_POOL_REGION}_${USER_POOL_ID}`,
  aws_user_pools_web_client_id: USER_POOL_CLIENT_ID,
  oauth: {
    domain: AUTH_DOMAIN,
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: REDIRECT_URL,
    redirectSignOut: `${REDIRECT_URL}/logout`,
    responseType: 'token',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS',
    ],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
} as const;

export default awsmobile;
